import {
  CreateVariables,
  FlagBulkTrashVariables,
  FlagUpdateVariables,
  Option,
} from "./../models/app";
import { DataStore, SortDirection } from "aws-amplify";
import { useDispatch } from "react-redux";
import { setListing, setSelected } from "../store/ducks/flag";
import { HeadCell } from "../models/dataTable";
import useApp from "./useApp";
import { Flag } from "../models";
import { FlagGetVariables, FlagListingVariables } from "../models/app";
import { CreateFlagInput } from "../models/GQL_API";
import { onCreateFlag } from "../graphql/subscriptions";

const useResource = (listingName: string, singleName: string) => {
  const dispatch = useDispatch();
  const { showConfirm, showError } = useApp();

  async function fetch(params: FlagListingVariables) {
    const { accountID, searchText, startIndex, limit } = params;

    // stop using this table
    return [];

    try {
      const listing = await DataStore.query(
        Flag as any,
        (model: any) => {
          model.accountID("eq", accountID).deleted("eq", "0");

          if (searchText.length > 0)
            model.message("contains", searchText.toLowerCase());

          return model;
        },
        {
          page: startIndex / limit,
          limit: limit,
          sort: (s) => s.createdAt(SortDirection.DESCENDING),
        }
      );

      // dispatch(setListing(listing));

      return listing;
    } catch (err: Error | any) {
      showError(err.message);
    }
  }

  /**
   * Get Resource Name
   *
   * @param id id: string
   *
   * @returns string
   */
  const getName = (params: FlagGetVariables) => {
    const { id, listing } = params;
    // stop using this table
    return "";

    // if (listing.length > 0) {
    //   const model = listing.find((model: Flag) => model.id === id);

    //   return model ? model.name : "";
    // }

    // return "";
  };

  async function get(params: FlagGetVariables) {
    const { id, listing } = params;
    // stop using this table
    return {};
    try {
      const single: Flag | undefined =
        listing.length === 0
          ? await DataStore.query(Flag as any, id)
          : listing.find((model: Flag) => model.id === id);

      return single;
    } catch (err) {
      showError(err);
    }
  }

  async function create(params: CreateVariables) {
    const { userID, userName, data } = params;
    // stop using this table
    return {};
    // if (!data.accountID) {
    //   const error = new Error(`Cannot create ${singleName} without accountID`);
    //   return showError(error);
    // }

    // try {
    //   const createInput: CreateFlagInput = {
    //     accountID: data.accountID,
    //     name: data.name.toLowerCase(),
    //     icon: data.icon ? data.icon : "",
    //     deleted: "0",
    //     createdAt: new Date().toISOString(),
    //     createdByID: userID,
    //     createdByName: userName,
    //   };

    //   if (data.color) createInput.color = data.color;

    //   await DataStore.save(new Flag(createInput as any));

    //   showConfirm(`New ${singleName} has been created successfully`);
    // } catch (err) {
    //   showError(err);
    // }
  }

  async function update(params: FlagUpdateVariables) {
    const { id, listing, data } = params;
    // stop using this table
    return {};
    // try {
    //   const original = await get({ id, listing });

    //   await DataStore.save(
    //     Flag.copyOf(original!, (updated) => {
    //       updated.name = data.name ? data.name.toLowerCase() : original!.name;
    //       updated.icon = data.icon ? data.icon : original!.icon;
    //       updated.color = data.color ? data.color : original!.color;
    //     })
    //   );

    //   showConfirm(`${singleName} has been updated successfully`);
    // } catch (err) {
    //   showError(err);
    // }
  }

  async function trash(params: FlagGetVariables) {
    try {
      // stop using this table
      return {};
      // const original = await get(params);

      // await DataStore.save(
      //   Flag.copyOf(original!, (updated) => {
      //     updated.deleted = "1";
      //   })
      // );

      // showConfirm(`${singleName} has been moved to trash successfully`);
    } catch (err) {
      showError(err);
    }
  }

  async function bulkTrash(params: FlagBulkTrashVariables) {
    const { ids, listing } = params;
    // stop using this table
    return {};

    ids.forEach(async (id: any) => {
      try {
        await trash(id);
      } catch (err: Error | any) {
        throw err;
      }
    });

    dispatch(setListing(listing.filter((model: any) => !ids.has(model.id))));

    showConfirm(`${ids.size} ${listingName} items has been moved to trash`);
  }

  async function remove(params: FlagGetVariables) {
    const { id, listing } = params;
    // stop using this table
    return {};
    try {
      await DataStore.delete(id as any);

      dispatch(setListing(listing.filter((model: any) => model.id !== id)));

      showConfirm(`${singleName} has been deleted successfully`);
    } catch (err: Error | any) {
      showError(err);
    }
  }

  function options(listing: Flag[]) {
    const options: Option[] = [];

    for (let option of listing) {
      options.push({ label: option.name, value: option.id });
    }

    return options;
  }

  const headCells: readonly HeadCell[] = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
    },
    {
      id: "createdBy",
      numeric: false,
      disablePadding: false,
      label: "Created By",
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Date",
    },
    {
      id: "actions",
      numeric: true,
      disablePadding: false,
      label: "",
    },
  ];

  const dataCells: readonly string[] = ["name"];

  const api: any = {};

  api[`${listingName}Model`] = Flag as any;
  api[`${listingName}CreateSubscription`] = onCreateFlag;

  api[`${listingName}Options`] = options;
  api[`${listingName}HeadCells`] = headCells;
  api[`${listingName}DataCells`] = dataCells;
  api[`${listingName}Fetch`] = fetch;
  api[`${listingName}Get`] = get;
  api[`${listingName}Create`] = create;
  api[`${listingName}Update`] = update;
  api[`${listingName}Trash`] = trash;
  api[`${listingName}BulkTrash`] = bulkTrash;
  api[`${listingName}Delete`] = remove;
  api[`${listingName}GetName`] = getName;
  api[`${listingName}ChangeListing`] = (listing: Flag[]) =>
    dispatch(setListing(listing));
  api[`${listingName}ChangeSelected`] = (conceptID: string) =>
    dispatch(setSelected(conceptID));

  return api;
};

export default useResource;
